import React, { useState } from 'react';
import {
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import { QuantityPricingFields } from '../../../Components/QuantityTable';

const tabClass = (active, tabId) =>
  active === tabId
    ? 'active text-primary fw-semibold text-uppercase py-3 px-4'
    : 'text-uppercase fw-semibold text-muted py-3 px-4';

const ParcelDeliveryPricingTabs = ({
  parcel,
  deliveryContent,
  defaultTab = 'delivery',
  showDeliveryUnitOnPricing = false,
}) => {
  const [activeTab, setActiveTab] = useState(defaultTab);

  return (
    <>
      <CardHeader className='bg-white p-0 border-bottom'>
        <Nav tabs className='nav-tabs m-0'>
          <NavItem>
            <NavLink
              tag='button'
              type='button'
              className={tabClass(activeTab, 'delivery')}
              onClick={() => setActiveTab('delivery')}
              style={{ cursor: 'pointer' }}
            >
              Delivery Unit
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              tag='button'
              type='button'
              className={tabClass(activeTab, 'pricing')}
              onClick={() => setActiveTab('pricing')}
              style={{ cursor: 'pointer' }}
            >
              Pricing
            </NavLink>
          </NavItem>
        </Nav>
      </CardHeader>
      <TabContent activeTab={activeTab}>
        <TabPane tabId='delivery'>{deliveryContent}</TabPane>
        <TabPane tabId='pricing'>
          <div className='p-4'>
            <QuantityPricingFields
              parcel={parcel}
              showDeliveryUnit={showDeliveryUnitOnPricing}
            />
          </div>
        </TabPane>
      </TabContent>
    </>
  );
};

export default ParcelDeliveryPricingTabs;
